import { gql } from '@apollo/client';

export const PATCH_CATEGORY_MUTATION = gql`
    mutation patchCategory($input: PatchCategoryInput!) {
        result: patchCategory(input: $input) {
            id
            name
            description
            brand {
                name
                id
            }
            sortOrder
            locales {
                code
                name
                description
            }
        }
    }
`;